import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class TrackingConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getMaskedParams(): Record<string, string> {
		return this.configService.get((x) => x.core.tracking.maskedParams, {
			name: "name",
			username: "user",
			email: "user@email.com",
			token: "00000-00000-0000",
		}) as Record<string, string>;
	}
}
